<template>
    <div class="manual">
        <slot name="top">
<!--            <div class="top">-->
<!--                <div class="big">Android安装说明</div>-->
<!--                <div class="small">请选择您的手机品牌仔细阅读<span class="span">安装说明</span></div>-->
<!--            </div>-->
        </slot>
      <div class="and-box">
        <div class="row rowHw" @click="choose('华为鸿蒙系统')"><img class="img" src="./images/brand_0.png" /></div>
        <div class="flex">
          <div class="brand" v-for="(item,index) in brands" :key="index" @click="choose(`${item}手机安装说明`)">
            <img class="img" :src="require(`./images/brand_${index+1}.png`)" />
            <div class="p">{{item}}</div>
          </div>
        </div>
        <div class="row gap_b">近日被某些杀毒软件误判为恶意软件，<br class="return" />我们承诺不会放置恶意程序，请您放心使用。</div>
      </div>

        <slot>
            <div class="row" @click="otherPhoneInfoSet({otherPhoneShow: true})">
                <img class="img" src="./images/hack_1.png" />
            </div>
            <div class="row" @click="choose('其它异常Tips')" >
                <img class="img" src="./images/hack_2.png" />
            </div>
            <div class="row" @click="choose('解除风险')" >
                <img class="img" src="./images/hack_3.png" />
            </div>
        </slot>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
	props: {
		phone_none: {
			type: Boolean,
			default() {
				return false
			}
		}
	},
	components: {},
	data() {
		return {
			brands: ["华为", "小米", "OPPO", "VIVO", "魅族", "一加", "Realme", "IQOO"],
		};
	},
	computed: {},
	methods: {
		...mapMutations('otherPhone', ['otherPhoneInfoSet']),
		choose(params) {
			this.$emit("choose", params)
		}
	},
	mounted() { },
};
</script>
<style lang="scss" scoped>
.and-box{
//   background:url("./images/and_bg.png")no-repeat;
//   background-size: 100% 100%;

  .rowHw{
    padding: 22px 10px 0;
    margin-bottom: -7px;
  }
}
.manual {
	font-size: 15px;
	padding-bottom: 25px;
	background: url('./images/bg.png') 0 0/100% auto no-repeat;
	&.basex2 {
		font-size: 15px * 2;
		padding-bottom: 25px * 2;
		.top {
			padding: 25px * 2 0;
			.big {
				font-size: 21px * 2;
				margin-bottom: 15px * 2;
			}
			.small {
				span {
					margin: 0 5px * 2;
				}
			}
		}
		.gap_b {
			margin-bottom: 10px * 2 !important;
		}
		.flex {
			margin: 0 15px * 2;
			& + .row {
				margin-top: 25px * 2;
			}
			.brand {
				.img {
					margin: 25px * 2 auto 15px * 2 auto;
					width: 50px * 2;
				}
			}
		}
		.row {
			margin: 0 15px * 2;
			& + .row {
				margin-top: 5px * 2;
			}
		}
	}
	&.dark {
		color: #fff;
		.top {
			.small {
				span {
					color: #fff;
				}
			}
		}
		.flex {
			.brand {
				.p {
					color: #fff;
				}
			}
		}
	}
	.top {
		text-align: center;
		line-height: 1;
		padding: 25px 0;
		display: block;
		.big {
			font-size: 21px;
			margin-bottom: 15px;
			font-weight: bolder;
		}
		.small {
			span {
				color: #3a68ff;
				text-decoration: underline;
				margin: 0 5px;
			}
		}
	}
	.gap_b {
		margin-bottom: 10px !important;
	}
	.return {
		display: none;
	}
	.flex {
		display: flex;
		flex-wrap: wrap;
		margin: 0 15px;
		& + .row {
			margin-top: 25px;
		}
		.brand {
			width: 25%;
			text-align: center;
			.img {
				display: block;
				margin: 25px auto 15px auto;
				width: 50px;
			}
			.p {
				color: #3a68ff;
				text-decoration: underline;
			}
		}
	}
	.row {
		//margin: 0 15px;
		& + .row {
			margin-bottom: 5px;
		}
		.img {
			display: block;
			width: 100%;
		}
	}
}
</style>
